import i18n from '@/common/i18n';
import computedLocale from '@/common/utils/computedLocale';
import { TaskName } from '@/common/constants/taskNames.constants';

export const HA_PENDING_TASKS = [
  TaskName.HA_CREATING,
  TaskName.HA_DELETING,
  TaskName.HA_REPLACING_NODE,
  TaskName.HA_ADDING_NODE,
  TaskName.HA_REMOVING_NODE,
  TaskName.HA_RECONFIGURING
];

type HAPendingText = Partial<Record<TaskName, string>>

export const HA_PENDING_TEXT = computedLocale<HAPendingText>(() => ({
  [TaskName.HA_CREATING]: i18n.t('Creating the HA configuration. Please wait...'),
  [TaskName.HA_DELETING]: i18n.t('Destroying the HA configuration. Please wait...'),
  [TaskName.HA_REPLACING_NODE]: i18n.t('Replacing a node in the HA configuration. Please wait...'),
  [TaskName.HA_ADDING_NODE]: i18n.t('Adding a node to the HA configuration. Please wait...'),
  [TaskName.HA_REMOVING_NODE]: i18n.t('Removing a node from the HA configuration. Please wait...'),
  [TaskName.HA_RECONFIGURING]: i18n.t('Reconfiguring high availability for the compute cluster. Please wait...')
}));

export const HA_MIN_NODES = 3;
export const HA_MAX_NODES = 5;
